import { Link } from "react-router-dom";
import {
  APP_NAME,
  APP_TAGLINE,
  EXPERIENCES,
} from "../../config/earthDayExperience";
import "./Dashboard.scss";

const CARDS = [
  {
    ...EXPERIENCES.study,
    accent: "sea",
    stat: "PDFs, reports, and toolkits",
  },
  {
    ...EXPERIENCES.course,
    accent: "gold",
    stat: "Paths for teach-ins and green skills",
  },
  {
    ...EXPERIENCES.facilitator,
    accent: "terracotta",
    stat: "Live session planning and refinement",
  },
];

export default function Dashboard() {
  return (
    <div className="dashboard-shell">
      <div className="dashboard-noise" />
      <div className="dashboard-wrapper">
        <section className="dashboard-hero">
          <div className="hero-copy">
            <p className="hero-kicker">Earth Day Edition</p>
            <h1>{APP_NAME}</h1>
            <p className="hero-body">{APP_TAGLINE}</p>
            <div className="hero-summary">
              <span>Climate literacy</span>
              <span>Teach-in planning</span>
              <span>Guided community action</span>
            </div>
          </div>

          <aside className="hero-panel">
            <div className="hero-panel-header">
              <span>Field Notes</span>
              <span>Earth Day 2026</span>
            </div>
            <p>
              Build from grounded research, shape local learning sessions, and
              turn curiosity into practical climate action.
            </p>
            <dl>
              <div>
                <dt>Focus</dt>
                <dd>Climate literacy for mixed audiences</dd>
              </div>
              <div>
                <dt>Mode</dt>
                <dd>Document-guided, Gemini-assisted</dd>
              </div>
              <div>
                <dt>Use case</dt>
                <dd>Schools, clubs, libraries, and community groups</dd>
              </div>
            </dl>
          </aside>
        </section>

        <section className="dashboard-grid" aria-label="Primary experiences">
          {CARDS.map((card) => (
            <Link
              key={card.route}
              to={card.route}
              className={`dashboard-card accent-${card.accent}`}
            >
              <div className="card-eyebrow">
                <span>{card.eyebrow}</span>
              </div>
              <h2>{card.heroLabel}</h2>
              <p>{card.description}</p>
              <div className="card-footer">
                <span>{card.stat}</span>
                <span className="card-cta">Open</span>
              </div>
            </Link>
          ))}
        </section>
      </div>
    </div>
  );
}
